import React, { useEffect, useState } from 'react';
import useStarfishAPI from 'hooks/useStarfishAPI';
import { SFEntityID } from 'utils/types';
import SortableTable from 'SF/table/SortableTable';
import TrackingRuleRow from './TrackingRuleRow';
import css from './TrackingRules.scss';
import Icon from 'SF/MaterialIcon';
import { sortBy } from 'lodash';
import { getWord } from 'utils/tenant';
import { pressedEnterOrSpace } from 'utils/accessibility';

const TrackingRules = ({ userId }) => {
    const [ showTrackingRules, setShowTrackingRules ] = useState(false);
    const [ trackingRules, setTrackingRules ] = useState([]);
    const [ trackingRuleResponse, callTrackingRuleAPI ] = useStarfishAPI();
    
    useEffect(() => {
        callTrackingRuleAPI('../instructor/getNotifyRules.html');
    }, [userId]);
    
    useEffect(() => {
        if (trackingRuleResponse.success) 
            setTrackingRules(sortBy(trackingRuleResponse.data.rules, 'name'))
    }, [trackingRuleResponse]);
    
    const renderTrackingRule = (trackingRule, index) => <TrackingRuleRow trackingRule={trackingRule} key={index} />;
    
    if (trackingRules.length === 0) return null;
    return (
        <>
            <a className={css['table-link']}
               tabIndex="0"
               role="button"
               onClick={() => setShowTrackingRules(!showTrackingRules)}
               onKeyDown={(e) => {
                   if (pressedEnterOrSpace(e)) {
                       e.preventDefault();
                       setShowTrackingRules(!showTrackingRules);
                   }
               }}>
                { showTrackingRules ? 
                    'Hide ' + getWord('tracker') + ' Item List' : 
                    'Show list of ' + getWord('tracker') + ' Items I may receive'
                }
            </a>
            { showTrackingRules &&
                <div className={css['container']}>
                    <span className={css['info']}><Icon icon='error'/>Indicates an emergency item; you will be notified immediately regardless of your notification preferences.</span>
                    <div className={css['table-container']} data-testid='notifyRulesTable'>
                        <SortableTable className={css['tracking-table']}
                                       columnToSort='name'
                                       headers={[{content: getWord('tracker') + ' Item'}]}
                                       items={trackingRules}
                                       shouldPaginate={false}
                                       renderItem={renderTrackingRule}/>
                    </div>
                </div>
            }
        </>
    );
};

TrackingRules.propTypes = {
    userId: SFEntityID.isRequired
};

export default TrackingRules;
